export type VersionChangedRefreshTimer = 0 | 1 | 2 | 3;

export const MAX_VERSION_CHANGED_REFRESH_TIMER_VALUE = 3;
